import React, { PropTypes, Component } from 'react';
import classes from '../index.scss';

class Invalid extends Component {
  submit = () => {
    this.props.callback('Close');
  }

  render() {
    return (
      <div className={classes['after-initial']}>
        <p className={classes['title']}>We're sorry.</p>
        <p className={classes['subtitle']}>The email address you provided isn’t valid for this promotion.</p>
        <div className={classes.button} onClick={this.submit}>
          <p>Continue Shopping</p>
        </div>
      </div>
    );
  }
}

Invalid.propTypes = {
  callback: PropTypes.func.isRequired,
};

export default Invalid;



/** WEBPACK FOOTER **
 ** ./apps/emailPromoModal/components/Invalid.js
 **/